export default "__VITE_ASSET__C$hvf9yE__"